/**
 * Venezuelan bolívar.
 */
export var VES = {
  code: 'VES',
  base: 10,
  exponent: 2
};